import gql from "graphql-tag";

export const PATIENT_PAY_CHECKOUT_ADDRESS_FIELDS = gql`
  fragment PatientPayCheckoutAddressFields on PatientPayCheckoutAddressType {
    id
    name
    line1
    line2
    city
    postcode
    country {
      id
      isoCode
      name
    }
    phoneNumber
  }
`;

export const PATIENT_PAY_CHECKOUT_PATIENT_PROFILE_FIELDS = gql`
  fragment PatientPayCheckoutPatientProfileFields on PatientPayCheckoutPatientProfileType {
    dateOfBirth
    gender
    user {
      firstName
      lastName
      email
    }
    guardian {
      user {
        firstName
        lastName
        email
      }
    }
  }
`;

export const PATIENT_PAY_CHECKOUT_PAGE_QUERY = gql`
  query PatientPayCheckoutPage($orderId: ID!, $authToken: String) {
    patientPayCheckoutPage(orderId: $orderId, authToken: $authToken) {
      alreadyPaid
      paymentAvailable
      paymentUnavailableReason
      canProceedToPayment
      order {
        id
        checkoutDate
        status
        totalDiscount
        sourceBasket {
          payee
          basketTotalPrice
          basketShippingCost
          currencySymbol
          organisation {
            name
          }
          shippingAddress {
            ...PatientPayCheckoutAddressFields
          }
        }
        testItems {
          id
          nameInBasket
          price
          parent {
            id
          }
          registeredUser {
            fullName
          }
          clinicLocation {
            fee
            address
            postCode
            clinic {
              name
            }
          }
        }
        supplementItems {
          id
          nameInBasket
          price
        }
      }
      patientProfile {
        ...PatientPayCheckoutPatientProfileFields
      }
    }
  }
  ${PATIENT_PAY_CHECKOUT_ADDRESS_FIELDS}
  ${PATIENT_PAY_CHECKOUT_PATIENT_PROFILE_FIELDS}
`;

export const PROCEED_TO_PATIENT_PAY_CHECKOUT_MUTATION = gql`
  mutation ProceedToPatientPayCheckoutMutation($input: ProceedToPatientPayCheckoutMutationInput!) {
    proceedToPatientPayCheckoutMutation(input: $input) {
      checkoutUrl
      errors {
        field
        messages
      }
    }
  }
`;

export const RESEND_PATIENT_PAY_CHECKOUT_LINK_MUTATION = gql`
  mutation ResendPatientPayCheckoutLinkMutation(
    $input: ResendPatientPayCheckoutLinkMutationInput!
  ) {
    resendPatientPayCheckoutLinkMutation(input: $input) {
      success
    }
  }
`;
